
import React from "react";

export function TableHeader() {
  return (
    <thead>
      <tr>
        <th className="w-[250px] bg-white/10 p-2 text-left font-medium text-white border-b border-white/10">
          Exercise
        </th>
        <th className="w-[80px] bg-white/10 p-2 text-center font-medium text-white border-b border-white/10">
          Sets
        </th>
        <th className="w-[80px] bg-white/10 p-2 text-center font-medium text-white border-b border-white/10">
          Reps
        </th>
        <th className="w-[80px] bg-white/10 p-2 text-center font-medium text-white border-b border-white/10">
          kgs
        </th>
        <th className="w-[120px] bg-white/10 p-2 text-center font-medium text-white border-b border-white/10">
          Intensity
        </th>
        <th className="w-[80px] bg-white/10 p-2 text-center font-medium text-white border-b border-white/10">
          Rest
        </th>
        <th className="flex-1 bg-white/10 p-2 text-left font-medium text-white border-b border-white/10">
          Notes
        </th>
      </tr>
    </thead>
  );
}
